module.exports = ".tag {\n  -webkit-box-shadow: 0 10px 10px -6px #dbdbdb;\n          box-shadow: 0 10px 10px -6px #dbdbdb; }\n\n.tags-container {\n  min-height: 96px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hunt/components/hunter-health/hunter-health.component.scss
// module id = ./src/app/hunt/components/hunter-health/hunter-health.component.scss
// module chunks = main